import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { Repository } from "@octopusdeploy/octopus-server-client";
import { OverviewContainer, OverviewHighlightText, TermsText } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import { useIsLicensedFeatureEnabled } from "~/components/LicensedFeature/useIsLicensedFeatureEnabled";
import { RequestTrial } from "~/components/RequestTrial/RequestTrial";
import { Note } from "~/components/form/index";
export const CommonConfigurationDeploymentFreezesOverview = () => {
    const isLicensedFeatureEnabled = useIsLicensedFeatureEnabled("GlobalDeploymentFreeze");
    const onRequestTrial = async (repository: Repository): Promise<void> => {
        await repository.DeploymentFreezes.requestTrial();
    };
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    <ExternalLink href="ProjectLevelDeploymentFreezes">Project-level Deployment Freezes</ExternalLink> let you temporarily or on a recurring schedule block deployments for a single project to protect critical windows, maintenance
                    periods, or business operations.
                </p>
            </OverviewHighlightText>
            {!isLicensedFeatureEnabled && (<div className={styles.calloutSpacing}>
                    <RequestTrial featureName={"Deployment Freezes"} content="Prevent deployments across multiple projects with global Deployment Freezes. Available on the Enterprise tier." dialogTitle="Request a free trial of global Deployment Freezes" onRequestTrial={onRequestTrial} variant="button"/>
                </div>)}
            <TermsText>
                <Note heading={"Pre-requisites"}>The resources you want to freeze need to be created prior to the creation of the deployment freeze.</Note>
                <Note heading={"Scoping deployment freezes"}>
                    Deployment freezes must be scoped to projects and environments or can be scoped to specific tenants if a more granular freeze is required. During deployment, Octopus will block deployments to the frozen resource(s).
                </Note>
                <Note heading={"Permissions"}>
                    To create and edit a deployment freeze, the DeploymentFreezeAdminister system permission is required. In addition, permissions will need to be scoped to all requested projects and environments when creating, editing or overriding
                    a deployment freeze. The DeploymentFreezeAdminister permission is included in the System Administrator, System Manager and Space Manager roles.
                </Note>
            </TermsText>
        </OverviewContainer>);
};
const styles = {
    calloutSpacing: css({
        marginTop: space[16],
    }),
};
